import { render } from "./purchase-details-offline.vue?vue&type=template&id=38a06ff8&scoped=true"
import script from "./purchase-details-offline.vue?vue&type=script&lang=js"
export * from "./purchase-details-offline.vue?vue&type=script&lang=js"

import "./purchase-details-offline.vue?vue&type=style&index=0&id=38a06ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a06ff8"]])

export default __exports__